// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/threads.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";

export const protobufPackage = "api.devplan.types.threads";

export enum ThreadStatus {
  UNKNOWN_THREAD_STATUS = 0,
  ACTIVE = 1,
  NON_ACTIVE = 2,
}

export function threadStatusFromJSON(object: any): ThreadStatus {
  switch (object) {
    case 0:
    case "UNKNOWN_THREAD_STATUS":
      return ThreadStatus.UNKNOWN_THREAD_STATUS;
    case 1:
    case "ACTIVE":
      return ThreadStatus.ACTIVE;
    case 2:
    case "NON_ACTIVE":
      return ThreadStatus.NON_ACTIVE;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ThreadStatus");
  }
}

export function threadStatusToJSON(object: ThreadStatus): string {
  switch (object) {
    case ThreadStatus.UNKNOWN_THREAD_STATUS:
      return "UNKNOWN_THREAD_STATUS";
    case ThreadStatus.ACTIVE:
      return "ACTIVE";
    case ThreadStatus.NON_ACTIVE:
      return "NON_ACTIVE";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ThreadStatus");
  }
}

/** Names must stay unchanged in the agent type since enum value names are used in thread ids. */
export enum AgentType {
  UNKNOWN_AGENT = 0,
  PRD_AGENT = 1,
  FEATURE_AGENT = 2,
  PROJECT_PLAN = 3,
  SUGGESTIONS_AGENT = 4,
  TASK = 5,
  DESCRIPTIONS = 6,
  CUSTOM_DOCUMENT = 7,
  CODING_ASSISTANT = 8,
  SUMMARIZATION = 9,
  SIMPLE_ACTION = 10,
  PRODUCT_TAB = 11,
  DEV_TAB = 12,
  TASK_PROMPT = 13,
  USER_STORIES = 14,
  PRODUCT_BRIEF = 15,
  TECH_BRIEF = 16,
  USER_STORY_TASKS = 17,
  PROJECT_TASKS = 18,
  QUICK_WINS = 19,
  DISCOVERY_AGENT = 20,
  DISCOVERY_BRIEF = 21,
  RICE_SCORE = 22,
  ATTACHMENT_PROCESSING = 23,
  USER_STORY_PROMPT = 24,
  WORKSPACE_CHAT = 25,
  SLACK_DM_CHAT = 26,
  KNOWLEDGE_AGENT = 27,
  BUG = 28,
  DASHBOARD_GENERATION = 29,
}

export function agentTypeFromJSON(object: any): AgentType {
  switch (object) {
    case 0:
    case "UNKNOWN_AGENT":
      return AgentType.UNKNOWN_AGENT;
    case 1:
    case "PRD_AGENT":
      return AgentType.PRD_AGENT;
    case 2:
    case "FEATURE_AGENT":
      return AgentType.FEATURE_AGENT;
    case 3:
    case "PROJECT_PLAN":
      return AgentType.PROJECT_PLAN;
    case 4:
    case "SUGGESTIONS_AGENT":
      return AgentType.SUGGESTIONS_AGENT;
    case 5:
    case "TASK":
      return AgentType.TASK;
    case 6:
    case "DESCRIPTIONS":
      return AgentType.DESCRIPTIONS;
    case 7:
    case "CUSTOM_DOCUMENT":
      return AgentType.CUSTOM_DOCUMENT;
    case 8:
    case "CODING_ASSISTANT":
      return AgentType.CODING_ASSISTANT;
    case 9:
    case "SUMMARIZATION":
      return AgentType.SUMMARIZATION;
    case 10:
    case "SIMPLE_ACTION":
      return AgentType.SIMPLE_ACTION;
    case 11:
    case "PRODUCT_TAB":
      return AgentType.PRODUCT_TAB;
    case 12:
    case "DEV_TAB":
      return AgentType.DEV_TAB;
    case 13:
    case "TASK_PROMPT":
      return AgentType.TASK_PROMPT;
    case 14:
    case "USER_STORIES":
      return AgentType.USER_STORIES;
    case 15:
    case "PRODUCT_BRIEF":
      return AgentType.PRODUCT_BRIEF;
    case 16:
    case "TECH_BRIEF":
      return AgentType.TECH_BRIEF;
    case 17:
    case "USER_STORY_TASKS":
      return AgentType.USER_STORY_TASKS;
    case 18:
    case "PROJECT_TASKS":
      return AgentType.PROJECT_TASKS;
    case 19:
    case "QUICK_WINS":
      return AgentType.QUICK_WINS;
    case 20:
    case "DISCOVERY_AGENT":
      return AgentType.DISCOVERY_AGENT;
    case 21:
    case "DISCOVERY_BRIEF":
      return AgentType.DISCOVERY_BRIEF;
    case 22:
    case "RICE_SCORE":
      return AgentType.RICE_SCORE;
    case 23:
    case "ATTACHMENT_PROCESSING":
      return AgentType.ATTACHMENT_PROCESSING;
    case 24:
    case "USER_STORY_PROMPT":
      return AgentType.USER_STORY_PROMPT;
    case 25:
    case "WORKSPACE_CHAT":
      return AgentType.WORKSPACE_CHAT;
    case 26:
    case "SLACK_DM_CHAT":
      return AgentType.SLACK_DM_CHAT;
    case 27:
    case "KNOWLEDGE_AGENT":
      return AgentType.KNOWLEDGE_AGENT;
    case 28:
    case "BUG":
      return AgentType.BUG;
    case 29:
    case "DASHBOARD_GENERATION":
      return AgentType.DASHBOARD_GENERATION;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum AgentType");
  }
}

export function agentTypeToJSON(object: AgentType): string {
  switch (object) {
    case AgentType.UNKNOWN_AGENT:
      return "UNKNOWN_AGENT";
    case AgentType.PRD_AGENT:
      return "PRD_AGENT";
    case AgentType.FEATURE_AGENT:
      return "FEATURE_AGENT";
    case AgentType.PROJECT_PLAN:
      return "PROJECT_PLAN";
    case AgentType.SUGGESTIONS_AGENT:
      return "SUGGESTIONS_AGENT";
    case AgentType.TASK:
      return "TASK";
    case AgentType.DESCRIPTIONS:
      return "DESCRIPTIONS";
    case AgentType.CUSTOM_DOCUMENT:
      return "CUSTOM_DOCUMENT";
    case AgentType.CODING_ASSISTANT:
      return "CODING_ASSISTANT";
    case AgentType.SUMMARIZATION:
      return "SUMMARIZATION";
    case AgentType.SIMPLE_ACTION:
      return "SIMPLE_ACTION";
    case AgentType.PRODUCT_TAB:
      return "PRODUCT_TAB";
    case AgentType.DEV_TAB:
      return "DEV_TAB";
    case AgentType.TASK_PROMPT:
      return "TASK_PROMPT";
    case AgentType.USER_STORIES:
      return "USER_STORIES";
    case AgentType.PRODUCT_BRIEF:
      return "PRODUCT_BRIEF";
    case AgentType.TECH_BRIEF:
      return "TECH_BRIEF";
    case AgentType.USER_STORY_TASKS:
      return "USER_STORY_TASKS";
    case AgentType.PROJECT_TASKS:
      return "PROJECT_TASKS";
    case AgentType.QUICK_WINS:
      return "QUICK_WINS";
    case AgentType.DISCOVERY_AGENT:
      return "DISCOVERY_AGENT";
    case AgentType.DISCOVERY_BRIEF:
      return "DISCOVERY_BRIEF";
    case AgentType.RICE_SCORE:
      return "RICE_SCORE";
    case AgentType.ATTACHMENT_PROCESSING:
      return "ATTACHMENT_PROCESSING";
    case AgentType.USER_STORY_PROMPT:
      return "USER_STORY_PROMPT";
    case AgentType.WORKSPACE_CHAT:
      return "WORKSPACE_CHAT";
    case AgentType.SLACK_DM_CHAT:
      return "SLACK_DM_CHAT";
    case AgentType.KNOWLEDGE_AGENT:
      return "KNOWLEDGE_AGENT";
    case AgentType.BUG:
      return "BUG";
    case AgentType.DASHBOARD_GENERATION:
      return "DASHBOARD_GENERATION";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum AgentType");
  }
}

export enum ThreadEntityType {
  UNKNOWN = 0,
  DOCUMENT = 1,
  GIT_REPO = 2,
  WORKSPACE_CHAT_ENTITY = 3,
}

export function threadEntityTypeFromJSON(object: any): ThreadEntityType {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return ThreadEntityType.UNKNOWN;
    case 1:
    case "DOCUMENT":
      return ThreadEntityType.DOCUMENT;
    case 2:
    case "GIT_REPO":
      return ThreadEntityType.GIT_REPO;
    case 3:
    case "WORKSPACE_CHAT_ENTITY":
      return ThreadEntityType.WORKSPACE_CHAT_ENTITY;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ThreadEntityType");
  }
}

export function threadEntityTypeToJSON(object: ThreadEntityType): string {
  switch (object) {
    case ThreadEntityType.UNKNOWN:
      return "UNKNOWN";
    case ThreadEntityType.DOCUMENT:
      return "DOCUMENT";
    case ThreadEntityType.GIT_REPO:
      return "GIT_REPO";
    case ThreadEntityType.WORKSPACE_CHAT_ENTITY:
      return "WORKSPACE_CHAT_ENTITY";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ThreadEntityType");
  }
}

export interface ThreadEntity {
  entityId: string;
  entityType: ThreadEntityType;
  agentType: AgentType;
  companyId: number;
}

export interface ThreadInfo {
  id: string;
  agentType: AgentType;
  companyId: number;
  documentId?: string | undefined;
  projectId?: string | undefined;
}

export interface ThreadExecutionInfo {
  thread: ThreadInfo | undefined;
  status: ThreadStatus;
  progress?: ThreadProgress | undefined;
}

export interface ThreadProgress {
  items: ThreadProgressItem[];
}

export interface ThreadProgressItem {
  id: string;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
  status: ThreadProgressItem_Status;
  message: string;
  error: string;
}

export enum ThreadProgressItem_Status {
  UNKNOWN = 0,
  ACTIVE = 1,
  FINISHED = 2,
}

export function threadProgressItem_StatusFromJSON(object: any): ThreadProgressItem_Status {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return ThreadProgressItem_Status.UNKNOWN;
    case 1:
    case "ACTIVE":
      return ThreadProgressItem_Status.ACTIVE;
    case 2:
    case "FINISHED":
      return ThreadProgressItem_Status.FINISHED;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ThreadProgressItem_Status");
  }
}

export function threadProgressItem_StatusToJSON(object: ThreadProgressItem_Status): string {
  switch (object) {
    case ThreadProgressItem_Status.UNKNOWN:
      return "UNKNOWN";
    case ThreadProgressItem_Status.ACTIVE:
      return "ACTIVE";
    case ThreadProgressItem_Status.FINISHED:
      return "FINISHED";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ThreadProgressItem_Status");
  }
}

function createBaseThreadEntity(): ThreadEntity {
  return { entityId: "", entityType: 0, agentType: 0, companyId: 0 };
}

export const ThreadEntity: MessageFns<ThreadEntity> = {
  encode(message: ThreadEntity, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.entityId !== "") {
      writer.uint32(10).string(message.entityId);
    }
    if (message.entityType !== 0) {
      writer.uint32(16).int32(message.entityType);
    }
    if (message.agentType !== 0) {
      writer.uint32(24).int32(message.agentType);
    }
    if (message.companyId !== 0) {
      writer.uint32(32).int32(message.companyId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ThreadEntity {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseThreadEntity();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entityId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.entityType = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.agentType = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ThreadEntity {
    return {
      entityId: isSet(object.entityId)
        ? globalThis.String(object.entityId)
        : isSet(object.entity_id)
        ? globalThis.String(object.entity_id)
        : "",
      entityType: isSet(object.entityType)
        ? threadEntityTypeFromJSON(object.entityType)
        : isSet(object.entity_type)
        ? threadEntityTypeFromJSON(object.entity_type)
        : 0,
      agentType: isSet(object.agentType)
        ? agentTypeFromJSON(object.agentType)
        : isSet(object.agent_type)
        ? agentTypeFromJSON(object.agent_type)
        : 0,
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
    };
  },

  toJSON(message: ThreadEntity): unknown {
    const obj: any = {};
    if (message.entityId !== "") {
      obj.entityId = message.entityId;
    }
    if (message.entityType !== 0) {
      obj.entityType = threadEntityTypeToJSON(message.entityType);
    }
    if (message.agentType !== 0) {
      obj.agentType = agentTypeToJSON(message.agentType);
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    return obj;
  },

  create(base?: DeepPartial<ThreadEntity>): ThreadEntity {
    return ThreadEntity.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ThreadEntity>): ThreadEntity {
    const message = createBaseThreadEntity();
    message.entityId = object.entityId ?? "";
    message.entityType = object.entityType ?? 0;
    message.agentType = object.agentType ?? 0;
    message.companyId = object.companyId ?? 0;
    return message;
  },
};

function createBaseThreadInfo(): ThreadInfo {
  return { id: "", agentType: 0, companyId: 0, documentId: undefined, projectId: undefined };
}

export const ThreadInfo: MessageFns<ThreadInfo> = {
  encode(message: ThreadInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.agentType !== 0) {
      writer.uint32(16).int32(message.agentType);
    }
    if (message.companyId !== 0) {
      writer.uint32(24).int32(message.companyId);
    }
    if (message.documentId !== undefined) {
      writer.uint32(34).string(message.documentId);
    }
    if (message.projectId !== undefined) {
      writer.uint32(42).string(message.projectId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ThreadInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseThreadInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.agentType = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.documentId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ThreadInfo {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      agentType: isSet(object.agentType)
        ? agentTypeFromJSON(object.agentType)
        : isSet(object.agent_type)
        ? agentTypeFromJSON(object.agent_type)
        : 0,
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      documentId: isSet(object.documentId)
        ? globalThis.String(object.documentId)
        : isSet(object.document_id)
        ? globalThis.String(object.document_id)
        : undefined,
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : undefined,
    };
  },

  toJSON(message: ThreadInfo): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.agentType !== 0) {
      obj.agentType = agentTypeToJSON(message.agentType);
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.documentId !== undefined) {
      obj.documentId = message.documentId;
    }
    if (message.projectId !== undefined) {
      obj.projectId = message.projectId;
    }
    return obj;
  },

  create(base?: DeepPartial<ThreadInfo>): ThreadInfo {
    return ThreadInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ThreadInfo>): ThreadInfo {
    const message = createBaseThreadInfo();
    message.id = object.id ?? "";
    message.agentType = object.agentType ?? 0;
    message.companyId = object.companyId ?? 0;
    message.documentId = object.documentId ?? undefined;
    message.projectId = object.projectId ?? undefined;
    return message;
  },
};

function createBaseThreadExecutionInfo(): ThreadExecutionInfo {
  return { thread: undefined, status: 0, progress: undefined };
}

export const ThreadExecutionInfo: MessageFns<ThreadExecutionInfo> = {
  encode(message: ThreadExecutionInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.thread !== undefined) {
      ThreadInfo.encode(message.thread, writer.uint32(10).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(16).int32(message.status);
    }
    if (message.progress !== undefined) {
      ThreadProgress.encode(message.progress, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ThreadExecutionInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseThreadExecutionInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.thread = ThreadInfo.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.progress = ThreadProgress.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ThreadExecutionInfo {
    return {
      thread: isSet(object.thread) ? ThreadInfo.fromJSON(object.thread) : undefined,
      status: isSet(object.status) ? threadStatusFromJSON(object.status) : 0,
      progress: isSet(object.progress) ? ThreadProgress.fromJSON(object.progress) : undefined,
    };
  },

  toJSON(message: ThreadExecutionInfo): unknown {
    const obj: any = {};
    if (message.thread !== undefined) {
      obj.thread = ThreadInfo.toJSON(message.thread);
    }
    if (message.status !== 0) {
      obj.status = threadStatusToJSON(message.status);
    }
    if (message.progress !== undefined) {
      obj.progress = ThreadProgress.toJSON(message.progress);
    }
    return obj;
  },

  create(base?: DeepPartial<ThreadExecutionInfo>): ThreadExecutionInfo {
    return ThreadExecutionInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ThreadExecutionInfo>): ThreadExecutionInfo {
    const message = createBaseThreadExecutionInfo();
    message.thread = (object.thread !== undefined && object.thread !== null)
      ? ThreadInfo.fromPartial(object.thread)
      : undefined;
    message.status = object.status ?? 0;
    message.progress = (object.progress !== undefined && object.progress !== null)
      ? ThreadProgress.fromPartial(object.progress)
      : undefined;
    return message;
  },
};

function createBaseThreadProgress(): ThreadProgress {
  return { items: [] };
}

export const ThreadProgress: MessageFns<ThreadProgress> = {
  encode(message: ThreadProgress, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      ThreadProgressItem.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ThreadProgress {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseThreadProgress();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.items.push(ThreadProgressItem.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ThreadProgress {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => ThreadProgressItem.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ThreadProgress): unknown {
    const obj: any = {};
    if (message.items?.length) {
      obj.items = message.items.map((e) => ThreadProgressItem.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ThreadProgress>): ThreadProgress {
    return ThreadProgress.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ThreadProgress>): ThreadProgress {
    const message = createBaseThreadProgress();
    message.items = object.items?.map((e) => ThreadProgressItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseThreadProgressItem(): ThreadProgressItem {
  return { id: "", createdAt: undefined, updatedAt: undefined, status: 0, message: "", error: "" };
}

export const ThreadProgressItem: MessageFns<ThreadProgressItem> = {
  encode(message: ThreadProgressItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(18).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(26).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(32).int32(message.status);
    }
    if (message.message !== "") {
      writer.uint32(42).string(message.message);
    }
    if (message.error !== "") {
      writer.uint32(50).string(message.error);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ThreadProgressItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseThreadProgressItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.error = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ThreadProgressItem {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      status: isSet(object.status) ? threadProgressItem_StatusFromJSON(object.status) : 0,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
      error: isSet(object.error) ? globalThis.String(object.error) : "",
    };
  },

  toJSON(message: ThreadProgressItem): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.status !== 0) {
      obj.status = threadProgressItem_StatusToJSON(message.status);
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    if (message.error !== "") {
      obj.error = message.error;
    }
    return obj;
  },

  create(base?: DeepPartial<ThreadProgressItem>): ThreadProgressItem {
    return ThreadProgressItem.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ThreadProgressItem>): ThreadProgressItem {
    const message = createBaseThreadProgressItem();
    message.id = object.id ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.status = object.status ?? 0;
    message.message = object.message ?? "";
    message.error = object.error ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
